window.MMAP_LAYOUT_VERSION = 6;
window.MMAP_GAP            = 15;
window.MMAP_PADDING_INNER  = 2;
window.MMAP_PADDING_OUTER  = 20;
window.MMAP_BAR_SCALE      = 1.0;

window.MMAP_3D_SECTOR_GAP  = 15;
window.MMAP_3D_BAR_GAP     = 12;
window.MMAP_3D_MAX_HEIGHT  = 0.3;

window.MMAP_BLDG_MIN_WIDTH   = 0.02;
window.MMAP_BLDG_MAX_WIDTH   = 0.10;
window.MMAP_BLDG_MEAN_HEIGHT = 0.18;
window.MMAP_BLDG_MAX_HDIFF   = 0.13;
window.MMAP_BLDG_INNER_GAP   = 2;
window.MMAP_BLDG_SECTOR_GAP  = 5;